import { CovidVaccineFeedbackModalPage } from './covid-vaccine-feedback-modal.page';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    component: CovidVaccineFeedbackModalPage,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CovidVaccineFeedbackModalPageRoutingModule {}
